/* eslint-disable @typescript-eslint/no-explicit-any */

import { paramCase } from 'change-case'
import { useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Module } from '../../helpers/types'
import { Single } from './displays/Single'
import { Stream } from './displays/Stream'
import { assetStyles } from './styles'

interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  assets: AssetReference[]
  content: string
  display: string
  index?: number
  isAccountPremium?: boolean
  isPresenting: boolean
  isSnapshot: boolean
  isThreaded?: boolean
  modules: Module[]
  onExpandAsset: () => void
  onRemoveAsset: () => void
  postType: string
  readOnly: boolean
  scheduledAt: string
  timezone: string
  updateCoverAsset: (data: FileList, assetId: number) => void
  updateText: (val: string, destination: string) => void
}

// TODO: Change default to Mobile Single in a later ticket
const displays: { [key: string]: React.FC<any> } = {
  mobileStream: Stream,
  desktopStream: Stream,
  mobileSingle: Single,
  desktopSingle: Single,
  default: Single,
}

const matchDisplay = (display: string): React.FC<any> =>
  displays[display] || displays.default

export const TwitterVideo: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  assets = [],
  content,
  display,
  index = -1,
  isAccountPremium,
  isPresenting = false,
  isSnapshot = false,
  isThreaded = false,
  modules = [],
  onExpandAsset = () => null,
  onRemoveAsset = () => null,
  postType,
  readOnly = false,
  scheduledAt,
  timezone,
  updateCoverAsset = () => null,
  updateText = () => null,
}) => {
  const RenderDisplay = matchDisplay(display)
  const video = assets.length ? assets[0] : null
  const modulesLength = modules ? modules.length : 0
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      css={assetStyles.baseStyles(display, postType)}
      className={kuiperClassNames(
        'twitter twitter-video',
        `twitter-${paramCase(display)}`
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        content={content}
        display={display}
        index={index}
        isAccountPremium={isAccountPremium}
        isHovered={isHovered}
        isPresenting={isPresenting}
        isSnapshot={isSnapshot}
        isThreaded={isThreaded}
        modulesLength={modulesLength}
        onContentChange={(val: string): void => updateText(val, 'content')}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        postType={postType}
        readOnly={readOnly}
        scheduledAt={scheduledAt}
        timezone={timezone}
        updateCoverAsset={updateCoverAsset}
        video={video}
      />
    </div>
  )
}
